// ── Acesso ao banco (Supabase): conferência de senha e helpers db* ─────────
// Extraído de App.js sem alteração de comportamento.
import { sb, makeCheckClient } from "./supabase";
import { PROFILE_COLS } from "./constants";

// Confere a senha sem trocar a sessão atual (um cliente separado, sem guardar nada).
// Assim, quem usa verificação em duas etapas não perde a sessão já verificada.
let _sbCheck = null;
export async function verifyPassword(email, password) {
  if (!_sbCheck) _sbCheck = makeCheckClient();
  const res = await _sbCheck.auth.signInWithPassword({ email, password });
  if (!res.error) { try { await _sbCheck.auth.signOut({ scope: "local" }); } catch {} }
  return res;
}

// ── DB HELPERS ────────────────────────────────────────────────────────────────
export async function dbGet(table, uid, fallback) {
  try {
    const { data, error } = await sb.from(table).select("data").eq("user_id", uid).single();
    // PGRST116 = "no rows found" (normal pra usuário novo); qualquer outro erro é logado
    // pra não mascarar problema de tabela/policy ausente (ex.: tabela "cycles").
    if (error && error.code !== "PGRST116") console.error(`dbGet(${table}) falhou:`, error);
    if (error || !data) return fallback;
    return data.data ?? fallback;
  } catch (e) { console.error(`dbGet(${table}) exceção:`, e); return fallback; }
}
export async function dbSet(table, uid, value) {
  try {
    const { error } = await sb.from(table).upsert({ user_id: uid, data: value, updated_at: new Date().toISOString() }, { onConflict: "user_id" });
    if (error) console.error(`dbSet(${table}) falhou:`, error);
  } catch (e) { console.error(`dbSet(${table}) exceção:`, e); }
}
export async function dbGetProfile(uid) {
  try {
    const { data } = await sb.from("profiles").select(PROFILE_COLS).eq("id", uid).single();
    return data;
  } catch { return null; }
}
export async function dbSetProfile(uid, fields) {
  try {
    await sb.from("profiles").update(fields).eq("id", uid);
  } catch {}
}
export async function dbGetTimerSec(uid) {
  try {
    const { data } = await sb.from("timer_seconds").select("seconds").eq("user_id", uid).single();
    return data?.seconds ?? 0;
  } catch { return 0; }
}
export async function dbAddTimerSec(uid, sec) {
  try {
    // fetch and update timer seconds
    const { data } = await sb.from("timer_seconds").select("seconds").eq("user_id", uid).single();
    const cur = data?.seconds ?? 0;
    await sb.from("timer_seconds").upsert({ user_id: uid, seconds: cur + sec, updated_at: new Date().toISOString() }, { onConflict: "user_id" });
  } catch {}
}
export async function dbAddStudySession(uid, sec, at = new Date()) {
  try {
    await sb.from("study_sessions").insert({ user_id: uid, seconds: sec, recorded_at: at.toISOString() });
  } catch {}
}
